import React from "react";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import Axios from "axios-https-proxy-fix";
import "./DialogEmailPictureBook.scss";
// Loading Dialog Dependencies 
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import ReactLoader from 'react-loader-spinner'
import Translated from "../../../components/Translated/Translated";
import translator from "../../../utils/translator";

function DialogEmailPictureBook(props) {
	const [open, setOpen] = React.useState(false);
	const [response, setResponse] = React.useState({});
	const [fileType, setFileType] = React.useState("");
	const [settings, setSettings] = React.useState({});
	const [loading_dialog, set_loading_dialog] = React.useState(null);
	const [wordLoading, setWordLoading] = React.useState(false);
	const [powerpointLoading, setPowerpointLoading] = React.useState(false);
	const [pdfLoading, setPdfLoading] = React.useState(false);

	let settingTitles = [
		["show_home_owner_homepage", translator("Admin Picturebook", "show_home_owner_homepage_label")], 
		["show_account_owner_homepage", translator("Admin Picturebook", "show_account_owner_label")], 
		["show_spec_links", "Show Spec Links"], 
		["show_project_name", translator("Admin Picturebook", "show_project_name_label")], 
		["show_home_owner_contact", translator("Admin Picturebook", "show_home_owner_contact_label")], 
		["include_notes", translator("Admin Picturebook", "include_notes_label")], 
		["show_pricing", translator("Admin Picturebook", "show_pricing_label")], 
		["show_vendor", translator("Admin Picturebook", "show_vendor_name_label")], 
		["show_model_number", translator("Admin Picturebook", "show_model_number_label")], 
		["show_sku_number", translator("Admin Picturebook", "show_sku_number")], 
		["show_product_quantity", translator("Admin Picturebook", "show_product_quantity")], 
		["show_summary", translator("Admin Picturebook", "show_summary")], 
		["show_standard_pricing", translator("Admin Picturebook", "show_standard_pricing")], 
		["show_website", translator("Admin Picturebook", "show_website")], 
		["picturebook_footer_show_page", translator("Admin Picturebook", "picturebook_footer_page_show_label")]
	];

	async function handleClose() {
		setOpen(false);
	}

	async function handleClickOpen(inputFileType) {
		setResponse({});
		setFileType(inputFileType);

		let ajaxURL = props.APIUrl + "/emco_quotes/picturebook-settings";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			project_id: props.projectId
		};
		let APIResponse = await Axios.post(ajaxURL, data);
		if (APIResponse.data.hasOwnProperty("error")) {
			setResponse(APIResponse.data);
		} else {
			setSettings(APIResponse.data.settings);
		}
		setOpen(true);
		switch (inputFileType) {
			case 'word':
				setWordLoading(false);
				break;
			case 'powerpoint':
				setPowerpointLoading(false);
				break;
			case 'pdf':
				setPdfLoading(false);
				break;
			default:
				break;
		}
	}

	async function submit() {
		let loading_dialog =
			<Dialog open={true} aria-labelledby="form-dialog-title"><DialogTitle id="form-dialog-title set-price-dialog-header">
				{translator("Misc", "sending_label")}{" "}
			</DialogTitle>
				<DialogContent style={{ paddingRight: "10em" }}>
					<ReactLoader
						style={{ marginLeft: "8em" }}
						type="Oval"
						color="#00BFFF"
						height={50}
						width={50}
					/>
				</DialogContent>
			</Dialog>
		set_loading_dialog(loading_dialog)
		let ajaxURL = props.APIUrl + "/emco_quotes/email-picturebook";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			project_id: props.projectId,
			language: props.language,
			type: fileType
		};
		data = settingTitles.reduce((final, arr) => {
			if (settings[arr[0]]) {
				final[arr[0]] = 1;
			} else {
				final[arr[0]] = 0;
			}
			return final;
		}, data);
		
		// Timer will display an email sent confirmation if the server times out
		// Important to start it BEFORE the actual call because it will never get reached
		const timeout = setTimeout(() => {
			displayResult();
			return;
		}, 60000);

		let APIResponse = await Axios.post(ajaxURL, data, { timeout: 60000, headers: { 'X-Foo': 'bar' } });

		// For projects that don't timeout - return a confirmation right away
		// So the user doesnt have to wait
		if (APIResponse) {
			clearTimeout(timeout);
			displayResult();
			return;
		}
	}

	async function displayResult() {
		let dataForResult = {
			project_id: props.projectId
		}
		// Find the repsonse message
		let picturebookResponse = await Axios.post(props.APIUrl + '/emco_quotes/email-picturebook-result', dataForResult, { timeout: 60000, headers: { 'X-Foo': 'bar' } });
		// Will either display an success or error message
		if (picturebookResponse.data) {
			setResponse(picturebookResponse.data);
			set_loading_dialog(null)
			return;
		}
		// Default.. just in case
		else {
			setResponse({ success: 'You have successfully emailed the Picture Book for this project!' });
			set_loading_dialog(null)
			return;
		}
	}

	function toggleSetting(key) {
		let newSettings = settings;
		newSettings[key] = newSettings[key] ? 0 : 1;
		setSettings(newSettings);
	}

	function formBody() {
		return (
			<div class="quote-dialog-body email-pbook-settings">
				<div class="email-pbook-settings-message"><Translated section="Misc" label="send_picturebook_dialog_message" /></div>
				<table>
					<tbody>
						{settingTitles.map(arr => {
							let [key, title] = arr;
							return (
								<tr>
									<td>{title}</td>
									<td>
										<input
											type="checkbox"
											id={key}
											onChange={e => {
												toggleSetting(e.target.id);
											}}
											defaultChecked={settings[key]}
										/>
										<label for={key}>
											<div class="email-pbook-checkmark">&#10003;</div>
										</label>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		);
	}

	function responseBody() {
		let class_names = "quote-dialog-body quote-dialog-";
		class_names += response.hasOwnProperty("error") ? "error" : "success";

		return (
			<div className={class_names}>
				<div>{response.hasOwnProperty("error") ? response.error : response.success}</div>
			</div>
		);
	}

	let hasResponse = Object.keys(response).length;

	return (
		<div class="quote-nav-component">
			<input type="radio" name="quote-nav-radio" id="email-picturebook-toggle" />
			<label class="quote-nav-top-link" for="email-picturebook-toggle">
				<div class="quote-dialog-arrow">&#9664;</div>
				<div><Translated section="Quote" label="sub_nav_picturebook" /></div>
			</label>

			<div class="quote-nav-sidedrop">
				<button
					onClick={e => {
						setWordLoading(true);
						handleClickOpen("word");
					}}
					class="quote-nav-sub-link"
					disabled={wordLoading ? true : false}
				>
					{wordLoading
						? <i class="fa fa-spinner fa-spin"></i>
						: "Word"
					}
				</button>
				<button
					onClick={e => {
						setPowerpointLoading(true);
						handleClickOpen("powerpoint");
					}}
					class="quote-nav-sub-link"
					disabled={powerpointLoading ? true : false}
				>
					{powerpointLoading
						? <i class="fa fa-spinner fa-spin"></i>
						: "Powerpoint"
					}
				</button>
				<button
					onClick={e => {
						setPdfLoading(true);
						handleClickOpen("pdf");
					}}
					class="quote-nav-sub-link"
					disabled={pdfLoading ? true : false}
				>
					{pdfLoading
						? <i class="fa fa-spinner fa-spin"></i>
						: "PDF"
					}
				</button>
			</div>
			<Dialog open={open} onClose={handleClose}>
				{loading_dialog}
				<div class="quote-dialog">
					<div class="quote-dialog-title"><Translated section="Misc" label="send_email_dialog_title" /></div>

					{hasResponse ? responseBody() : formBody()}

					<div class="quote-dialog-footer">
						<button class="quote-dialog-button" onClick={handleClose}>
							{hasResponse ? "CLOSE" : "CANCEL"}
						</button>
						{hasResponse ? (
							""
						) : (
								<button class="quote-dialog-button" onClick={submit}>
									<Translated section="Misc" label="send_btn" />
							</button>
							)}
					</div>
				</div>
			</Dialog>
		</div>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	projectId: state.projectIdUsedToIncreaseProductQuantity
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DialogEmailPictureBook);
